<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Registration</h1>

                <fieldset class="mt-4">
                    <div v-for="(item,index) in contactList" :key="index" class="form-row mb-2">
                        <div v-if="index ===0 || index === 2" class="col-12 col-md-12 form-group">
                            <h2>{{item.question}}</h2>
                        </div>
                        <div v-else class="col-12 col-md-4 form-group">
                            <label :for="item.question">{{item.question}}</label>
                            <input type="text" title="Click or tab here to enter text" :id="item.question" autocomplete="off" class="form-control form-control-md" v-model="item.answer" />
                        </div>
                    </div>            
                    <div class="row mt-5">
                        <div class="col">
                            <button type="button" class="btn btn-outline-secondary" @click="prevpage">Previous page</button>
                        </div>
                        <div class="col-auto">				
                            <button type="button" class="btn btn-primary float-right" @click="nextpage">{{buttonLabel}}</button>
                        </div>
                    </div>
                </fieldset>
            </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>

<script>
	export default {
        name: 'propertyinfo',
        data: function () {
            return {
                contact: {
                    question: '',
                    answer: ''
                },
                datareader: false,
                returnjson: {
                    "propertyinfo": {},
                    "propertydetail": [],
                    propertydetailcount: 0
                },
                buttonLabel: "Next",
                hasAccount: false,
                summaryPage: false
            }
        },
        mounted() {
            this.$store.dispatch("GET_CONTACT");

            this.hasAccount = this.$store.getters.HASACCOUNT;
            this.summaryPage = this.$store.getters.SUMMARYPAGE;
            if (this.summaryPage)
                this.buttonLabel = "View summary";
        },
        computed: {
            contactList() {
                let data = this.$store.getters.CONTACT_LIST;

                if (data.length === 0) {
                    data = this.$store.getters.CONTACT;
                }
                else {
                    data = data[0];
                }
                return data;
            }
        },
        //created() {
        //    this.getContact();
        //},
        methods: {
            //getContact() {
            //    this.contact = this.$store.getters.CONTACT;

            //    this.$store.dispatch("getContact");
            //    alert(this.$store.state.contact);
            //    console.log(this.$store.state.contact);
            //    this.contact = this.$store.state.contact;
            //    alert(this.contact.length);
            //    this.returnjson = this.$store.state.returnjson;

            //    if (this.returnjson.propertydetailcount > 0)
            //        this.buttonLabel = "View property";
            //},
            nextpage() {
                let data = this.contactList;

                for (let i = 0; i < data.length; i++) {
                    let q = data[i].question;
                    let a = data[i].answer;
                    if (a === "" && i !== 0 && i !== 2) {
                        alert("\"" + q + "\" is mandatory.");
                        return false;
                    }
                }
                this.$store.dispatch("SAVE_CONTACT_LIST", this.contactList);
    
                let nextPage = "Detail";
                let summaryPage = this.$store.getters.SUMMARYPAGE;
                if( summaryPage )
                    nextPage = "Summary";

                //this.$router.push({ name: 'Detail', params: { parameters: this.contactList } });
                this.$router.push({ name: nextPage });
            },
            prevpage() {
                let nextPage = "CreateAccount";
                if (this.hasAccount === true)
                    nextPage = "Account";

                this.$router.push({ name: nextPage });
            }
        }
	}
</script>